'use client';

import { createContext } from "react";
const o = createContext({
  color: "currentColor",
  size: "1em",
  weight: "regular",
  mirrored: false
});
export {
  o as IconContext
};
